<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <div
            class="d-flex flex-column flex-md-row justify-content-between align-items-center"
          >
            <div class="col-12 col-md-2">
              <bita-bootbutton
                v-if="this.$acl.isSuperAdmin || $acl.can('create', 'owners')"
                type="primary"
                title="صاحب بار جدید"
                icon="fas fa-plus-square"
                class="w-100"
                @click.native="statusChangeModalCreate"
              />
            </div>
          </div>
          <div style="text-align: center; margin-bottom: 20px">
            <transition name="fade">
              <div v-show="showFilters">
                <hr />
                <bita-form ref="form">
                  <div slot="body">
                    <div class="row">
                      <!-- جستجو عمومی -->
                      <bita-input
                        type="text"
                        name="search"
                        label="جستجو"
                        rules=""
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        v-model.lazy="filters.search"
                        @change="(e) => userSearch(e)"
                        subtitle="جستجو بر اساس نام،کد شرکت ، فامیل یا شماره موبایل"
                      />

                      <!-- وضعیت EBL -->
                      <bita-select
                        name="check_ebl"
                        label="وضعیت EBL"
                        ref="eblDropDown"
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        :data-source="eblStatuses"
                        data-text-field="name"
                        data-value-field="value"
                        v-model="filters.check_ebl"
                        @change="(e) => userSearch(e)"
                      />

                      <!-- شهر -->
                      <bita-select
                        name="city_id"
                        label="شهر"
                        ref="citiesDropDown"
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        :data-source="Allcities"
                        data-text-field="label"
                        data-value-field="id"
                        v-model="filters.city_id"
                        @change="(e) => userSearch(e)"
                      />
                      <bita-select
                        type="salon"
                        name="salon"
                        label="سالن پیش‌فرض"
                        validation-container-class="col-lg-2"
                        input-class="form-control"
                        :data-source="salons"
                        data-text-field="name"
                        data-value-field="id"
                        v-model="filters.salon_id"
                        @change="(e) => userSearch(e)"
                      />
                    </div>
                  </div>
                </bita-form>
              </div>
            </transition>
          </div>

          <hr />
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :hasRow="false"
          />
        </div>
      </bita-ibox>
    </div>

    <form-modal
      ref="editModal"
      :isLoading="isLoadingModal"
      :props-data="updateForm"
      :all-cities="Allcities"
      modal-id="edit-modal"
      title="ویرایش صاحب بار"
      @on-submit="handleEdit"
    />

    <form-modal
      ref="createModal"
      :isLoading="isLoadingModal"
      :props-data="createForm"
      :all-cities="Allcities"
      modal-id="create-modal"
      title="صاحب بار جدید"
      @on-submit="handleCreate"
    />

    <password-modal
      ref="password"
      :isLoading="isLoadingModal"
      :propsUser="selectedUser"
      modal-id="password-modal"
      title="تغییر رمز"
      @on-submit="changePassword"
    />

    <ownerload-modal
      ref="ownerLoadEditor"
      :isLoading="isLoadingModal"
      :props-data="ownerLoad"
      :props-load="getAllLoads"
      :props-load-parent="getLoadParents"
      modal-id="ownerload-modal"
      title="مشخصات بار"
      @on-submit="handleOwnerModal"
    />

    <black-list
      ref="blackList"
      :isLoading="isLoadingModal"
      :props-data="owner"
      modal-id="black-list"
      title="رانندگان مسدود"
    />

    <view-modal
      modal-id="view-modal"
      title="مشخصات صاحب بار"
      :props-data="updateForm"
    />
    <broker-owner
      ref="borkerOwner"
      modal-id="broker-owner"
      :props-owner="owners"
      :props-data="updateForm"
      title="افزودن زیر مجموعه به بروکر"
      :is-loading="isLoadingModal"
    />
    <form-role
      ref="editRole"
      :isLoading="isLoadingModal"
      :props-data="roleData"
      :props-roles="roles"
      modal-id="edit-role"
      @on-submit="handleEditRole"
    />
    <salons-modal modal-id="salons-modal" :props-driver="propsDriver" />

    <!-- Actions -->
    <g-context-menu ref="contextMenu" :width="280" #default="{items: owner}">
      <g-list>
        <g-list-item
          title="مشاهده بارها"
          icon="fa fa-eye"
          @click="view(owner)"
        />
        <g-list-item
          v-if="$acl.isSuperAdmin || $acl.can('edit', 'usersalons')"
          title="سالن ها"
          icon="fas fa-sort"
          @click="salonsOfOwner(owner)"
        />
        <g-list-item
          v-if="$acl.isSuperAdmin || $acl.can('update', 'userroles')"
          title="مشاهده سطح دسترسی"
          icon="fas fa-shield-alt"
          @click="roleEdit(owner.user)"
        />
        <g-list-item
          v-if="$acl.isSuperAdmin || $acl.can('update', 'owners')"
          title="تغییر دسترسی"
          icon="fas fa-address-card"
          @click="brokerChange(owner)"
        />
        <g-list-item
          v-if="$acl.isSuperAdmin || $acl.can('read', 'owners')"
          title="افزودن زیر مجموعه به واسطه گر"
          icon="fas fa-users"
          @click="brokerTeam(owner)"
        />
        <g-list-item
          title="افزودن رانندگان به بلک لیست"
          icon="fas fa-user-lock"
          @click="blackList(owner)"
        />
        <g-list-item
          v-if="$acl.isSuperAdmin || $acl.can('update', 'owners')"
          title="ویرایش صاحب بار"
          icon="fas fa-pen-square"
          @click="edit(owner)"
        />
        <g-list-item
          v-if="$acl.isSuperAdmin || $acl.can('delete', 'users')"
          title="پایان نشست کاربر"
          icon="fas fa-user"
          @click="expireToken(owner)"
        />
        <g-list-item
          v-if="$acl.isSuperAdmin || $acl.can('delete', 'owners')"
          title="حذف صاحب بار"
          icon="fas fa-times"
          @click="deleteOwner(owner)"
        />
        <template v-if="owner.documents_file">
          <g-list-item
            title="دانلود اسناد"
            icon="fas fa-download"
            @click="handleDownloadDocuments(owner.documents_file)"
          />
        </template>
        <g-list-item
          v-if="$acl.isSuperAdmin || $acl.can('update', 'users')"
          title="تغییر وضعیت"
          icon="fas fa-lock"
          @click="status(owner)"
        />
        <g-list-item
          title="تغییر رمز عبور"
          icon="fas fa-key"
          @click="openPasswordModal(owner.user)"
        />
      </g-list>
    </g-context-menu>
  </div>
</template>
<script>
import OwnersForm from "./From";
import OwnersView from "./View";
import PasswordForm from "./PasswordForm.vue";
import OwnerLoad from "./OwnerLoad";
import BrokerOwner from "./components/BrokerOwnerForm";
import BlackList from "./components/BlackListForm";
import GContextMenu from "../../../components/GContextMenu.vue";
import GList from "../../../components/listItem/GList.vue";
import GListItem from "../../../components/listItem/GListItem.vue";
import SalonsForm from "./SalonsForm.vue";
import UserRole from "./Role";

export default {
  components: {
    "form-modal": OwnersForm,
    "view-modal": OwnersView,
    "password-modal": PasswordForm,
    "ownerload-modal": OwnerLoad,
    "form-role": UserRole,
    "salons-modal": SalonsForm,
    BrokerOwner,
    BlackList,
    GContextMenu,
    GList,
    GListItem,
  },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "مدیریت کاربران",
          link: "/",
        },
        {
          title: "مدیریت صاحب بار ها",
          link: "/management/owners",
          active: true,
        },
      ],
      showFilters: true,
      filters: {
        search: "",
        check_ebl: "",
        city_id: "",
        salon_id: ""
      },
      isLoadingGrid: false,
      isLoadingModal: false,
      owners: [],
      createForm: {},
      updateForm: {},
      getAllLoads: [],
      getLoadParents: {},
      ownerLoad: {},
      owner: {},
      roleData: {},
      roles: [],
      salons: [],
      selectedUser: {},
      propsDriver: {},
      eblStatuses: [
        { name: "فعال", value: 1 },
        { name: "غیرفعال", value: 0 },
      ],
      Allcities: [],
      gridColumns: [
        { title: "#", template: this.getTemplateID, width: "40px" },
        { field: "name", title: "نام", width: 180 },
        { field: "company_code", title: "کد شرکت", width: 50 },
        {
          title: "نماینده",
          width: "100px",
          template: (e) => (e.user ? e.user.full_name : "-"),
        },
        {
          title: "نام کاربری",
          width: "110px",
          template: (e) => (e.user ? e.user.username : "-"),
        },
        {
          title: "شماره تماس",
          width: "100px",
          template: (e) => (e.user ? e.user.phone : "-"),
        },
        {
          title: "استان / شهر",
          width: 150,
          template: (e) =>
            `${e.user?.city?.province?.name || "-"} / ${e.user?.city?.name ||
              "-"}`,
        },
        // {
        //   title: "استان",
        //   template: (e) => e.user?.city?.province?.name || "-",
        //   width: 100,
        // },
        // {
        //   title: "شهر",
        //   template: (e) => e.user?.city?.name || "-",
        //   width: 100,
        // },
        {
          title: "وضعیت ebl",
          width: "70px",
          template: (e) => this.statusText(e),
        },
        {
          field: "request_count",
          title: "تعداد بار اعلام شده",
          width: 120,
        },
        {
          field: "balance",
          title: "اعتبار (تماس)",
          width: 120,
          template: (e) => (e.user && e.user.balance ? e.user.balance.call_balance : "-"),
        },
        {
          field: "last_ebl_call",
          title: "آخرین فراخوانی ebl",
          template: (e) =>
            e.last_ebl_call ? this.$getJalaliDateTime(e.last_ebl_call) : "",
          width: 90,
        },

        {
          title: "صاحب بار ",
          width: "70px",
          template: (e) => this.userStatusText(e),
        },
        {
          field: "created_at",
          title: "تاریخ ایجاد",
          template: (e) =>
            e.created_at ? this.$getJalaliDateTime(e.created_at) : "",
          width: 90,
        },
        {
          title: "عملیات",
          command: [],
          width: 50,
        },
      ],
    };
  },
  computed: {},
  mounted() {
    Promise.all([this.getRoles(),this.getSalons(),
]).then((res) => {
      this.roles = res[0].data;
      this.salons = res[1].data;
    });

    Promise.all([this.getLoadParent(), this.getAllCity()]).then((res) => {
      this.getLoadParents = res[0].data;
      this.Allcities = res[1].data;
    });
    this.loadData();
    this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
  },
  methods: {
    statusText(e) {
      let color = e.check_ebl ? "#60e95f" : "#FF0000";
      let text = e.check_ebl ? "فعال" : "غیرفعال";
      return `<span class='label' style="color:white;background-color:${color}">${text}</span>`;
    },
    userStatusText(e) {
      if (!e.user) {
        return `<span class='label' style="color:white;background-color:gray">-</span>`;
      }

      const color = e.user.is_active ? "#1AB394" : "#FF0000";
      const text = e.user.is_active ? "فعال" : "غیرفعال";
      return `<span class='label' style="color:white;background-color:${color}">${text}</span>`;
    },

    isBrokerText(_broker) {
      return _broker ? "<span class='label label-primary'> بروکر </span>" : "-";
    },
    getTemplateID() {
      return this.$refs.grid.getTemplateLocal();
    },
    readData(e) {
      this.$resetGrid();
      this.isLoadingGrid = true;
      let baseUrl = `owners?include=user.city,user.roles`;
      let url = this.$makeQueryStringForSpatie(baseUrl, this.filters, "&");
      this.$persistClient("get", url)
        .then((res) => {
          this.owners = res.data;
          e.success(res.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    getSalons() {
      return this.$persistClient("get", "salons");
    },
    statusChangeModalEdit() {
      this.showModalEdit = !this.showModalEdit;

      $("#edit-modal")
        .modal()
        .modal("toggle");
    },
    statusChangeModalCreate() {
      $("#create-modal")
        .modal()
        .modal("toggle");
    },
    statusChangeModalView() {
      this.$toggleModal("#view-modal");
    },
    statusChangeModalOwnerLoad() {
      $("#ownerload-modal")
        .modal()
        .modal("toggle");
    },

    statusChangeModalBlackList() {
      $("#black-list")
        .modal()
        .modal("toggle");
    },

    gridCommands() {
      return [
        {
          text: "view",
          click: this.showActions,
          template:
            "<a role='button' class='k-button k-button-icontext k-grid-view'><span class='fas fa-ellipsis-v' style='color:rgb(20 169 217)'></span></a>",
        },
      ];
    },
    showActions(e) {
      e.originalEvent.stopPropagation();

      const request = this.$refs.grid.getSelectedGridRow(e);

      this.$refs.contextMenu.init(e.originalEvent, request);
    },
    brokerTeam(owner) {
      this.isLoadingModal = true;
      this.$refs.borkerOwner.setData(owner);
      this.$toggleModal("#broker-owner");
      this.isLoadingModal = false;
    },
    brokerChange(owner) {
      this.isLoadingModal = true;
      this.$alert(
        "question",
        `از تغییر دسترسی ${owner.name} اطمینان دارید؟`,
        "",
        {
          confirmButtonText: "بله",
        },
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          let data = {
            is_broker: !owner.is_broker,
          };
          this.$persistClient("patch", `owners/${owner.id}/broker-state`, data)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    edit(owner) {
      this.isLoadingModal = true;
      const _this = this;
      let data = {
        id: owner.id,
        company_name: owner.name,
        company_code: owner.company_code,
        loading_fee: owner.loading_fee,
        check_ebl: owner.check_ebl,
        name: owner.user?.name,
        family: owner.user?.family,
        national_code: owner.user?.national_code,
        phone: owner.user?.phone,
        username: owner.user?.username || "",
        postal_code: owner.user?.postal_code || "",
        address: owner.user?.address || "",
        city_id: owner.user?.city?.id || "",
        password: owner.password || "",
      };

      setTimeout(() => {
        _this.updateForm = data;
        _this.statusChangeModalEdit();
        _this.isLoadingModal = false;
      }, 200);
    },
    statusChangeModalRoleEdit() {
      this.$toggleModal("#edit-role");
    },
    roleEdit(user) {
      const _this = this;
      this.isLoadingmodal = true;
      let role = collect(user.roles)
        .pluck("id")
        .toArray();
      role = role.filter(function(e) {
        return e != null;
      });

      setTimeout(function() {
        _this.roleData = { user_id: user.id, role_name: role };
        _this.isLoadingModal = false;
        _this.statusChangeModalRoleEdit();
      }, 300);
    },
    handleEditRole(e) {
      this.isLoadingModal = true;
      let data = {
        role_name: e.role_name,
      };
      this.$persistClient("patch", `users/${e.user_id}`, data)
        .then((res) => {
          this.$izitoast("success", "موفق", res.data.message);
          this.loadData();
          this.statusChangeModalRoleEdit();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    deleteOwner(owner) {
      this.$alert(
        "question",
        `آیا از حذف صاحب بار ${owner.name} اطمینان دارید ؟`,
        "",
        {
          confirmButtonText: "بله",
        },
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          this.$persistClient("delete", `owners/${owner.id}`)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    handleDownloadDocuments(documentsUrl) {
      window.open(documentsUrl, "_blank");
    },
    expireToken(owner) {
      this.$alert(
        "question",
        `آیا از پایان نشست کاربر  ( ${owner?.user?.name} ) اطمینان دارید ؟`,
        "",
        {
          confirmButtonText: "بله",
        },
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          this.$persistClient(
            "delete",
            `users/${owner?.user?.id}/revokeUserTokens`,
          )
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    getRoles() {
      return this.$persistClient("get", "roles");
    },
    viewLoad(owner) {
      this.isLoadingModal = true;
      this.ownerLoad = owner;
      const _this = this;
      setTimeout(function() {
        _this.$refs.ownerLoadEditor.loadData();
        _this.isLoadingModal = false;
      }, 300);
      this.statusChangeModalOwnerLoad();
    },

    blackList(owner) {
      this.isLoadingModal = true;
      this.owner = owner;
      const _this = this;
      setTimeout(function() {
        _this.$refs.blackList.readData();
        _this.isLoadingModal = false;
      }, 300);
      this.statusChangeModalBlackList();
    },
    status(owner) {
      this.$alert(
        "question",
        `آیا از تغییر وضعیت این صاحب بار اطمینان دارید؟`,
        "",
        {
          confirmButtonText: "بله",
        },
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          let status = {
            is_active: !owner?.user?.is_active,
          };
          if (!owner.user) {
            this.$izitoast("error", "اطلاعات صاحب بار ناقص است.");
            this.isLoadingGrid = false;
          } else {
            this.$persistClient("patch", `users/${owner.user.id}`, status)
              .then((res) => {
                this.$izitoast("success", "عملیات موفق", res.data.message);
                this.loadData();
              })
              .finally(() => {
                this.isLoadingGrid = false;
              });
          }
        }
      });
    },
    handleCreate(data) {
      this.isLoadingModal = true;

      this.$persistClient("post", "owners/owner-user", data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.messages);

          this.createForm = {};

          this.loadData();
          this.$refs.createModal.reset();

          this.statusChangeModalCreate();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    changePassword(e) {
      this.isLoadingModal = true;
      let data = {
        new_password: e.new_password,
        confirm_password: e.confirm_password,
      };
      this.$persistClient("patch", `users/${e.user_id}/change-password`, data)
        .then((res) => {
          this.$izitoast(
            "success",
            "موفق",
            res.data.message || "رمز عبور با موفقیت تغییر کرد",
          );
          this.loadData();
          this.statusChangeModalPassword();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    openPasswordModal(user) {
      console.log(user);
      this.isLoadingModal = true;
      this.selectedUser = user;

      const _this = this;
      setTimeout(function() {
        _this.isLoadingModal = false;
      }, 300);

      this.statusChangeModalPassword();
    },
    statusChangeModalPassword(user) {
      $("#password-modal")
        .modal()
        .modal("toggle");
    },

    handleEdit(data) {
      this.isLoadingModal = true;

      const form = {
        company_name: data.company_name,
        loading_fee: data.loading_fee,
        company_code: data.company_code,
        check_ebl: data.check_ebl,
        city_id: data.city_id,
        name: data.name,
        family: data.family,
        national_code: data.national_code,
        phone: data.phone,
        postal_code: data.postal_code,
        username: data.username,
        address: data.address,
      };

      this.$persistClient("patch", `owners/${data.id}/owner-user`, form)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);
          this.loadData();
          this.$refs.editModal.reset();

          this.statusChangeModalEdit();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    salonsOfOwner(owner) {
      this.propsDriver = {
        id: owner.user.id,
        full_name: owner?.user.full_name,
      };
      this.$toggleModal("#salons-modal");
    },
    handleOwnerModal() {},
    getLoadParent() {
      return this.$persistClient("get", "loads?filter[parentItem]=0");
    },
    userSearch: _.debounce(function() {
      this.loadData();
    }, 1000),

    getAllCity() {
      this.isLoadingAllCities = true;
      return this.$persistClient("get", `cities?filter[unProvince]=0`).finally(
        () => {
          this.isLoadingAllCities = false;
        },
      );
    },
    view(owner) {
      this.$router.push(`/management/owner/${owner.id}/requests`);
    },
  },
};
</script>
<style scoped>
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease-in;
}
.fade-leave {
  opacity: 0.2;
}
</style>
